import {Component, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {MaintenanceService} from '../../../services/maintenance.service';
import {Maintenance} from '../../../models/maintenance.model';
import {MachineMaintenance} from '../../../models/machine.maintenance.model';

@Component({
  providers: [MaintenanceService],
  selector: 'app-maintenance-details',
  templateUrl: './maintenance.details.component.html'
})
export class MaintenanceDetailsComponent implements OnDestroy, OnInit {
  public maintenance: Maintenance;

  private _selectedMaintenance: MachineMaintenance;
  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute, private _maintenanceService: MaintenanceService,
              private _elementReference: ElementRef, public router: Router) {}

  public ngOnInit() {
    this._route.params
      .takeUntil(this._ngUnSubscribe)
      .subscribe(params => {
        const maintenanceId = params['id'];

        if (maintenanceId) {
          this._maintenanceService.load(maintenanceId);
          this._maintenanceService.maintenances$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              maintenances => {
                this.maintenance = maintenances.find(pr => pr._id === maintenanceId);
              }
            );
        }
      });
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  set selectedMaintenance(value: MachineMaintenance) {
    this._selectedMaintenance = value;
    this.maintenanceDetails();
  }

  get selectedMaintenance(): MachineMaintenance {
    return this._selectedMaintenance;
  }

  public maintenanceDetails(): void {
    if (this.selectedMaintenance) {
      this.router.navigate(['/machinemaintenances', this.selectedMaintenance._id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/maintenance/details/maintenance.details.component.ts